import {
  EStatus,
  ICreateActionCheckResponse,
} from '../../../../repositories/moderation-action-check/v1/create-action-check';
import { EFairPlayErrorCode } from '../../../../types/reducers/fairPlay';
import { TJoinFairPlayResult } from '../types';

export function mapSuccessResponse(response: ICreateActionCheckResponse): TJoinFairPlayResult {
  const { status, message } = response;

  switch (status) {
    case EStatus.Accepted:
      return { success: true };

    case EStatus.Declined:
      return {
        success: false,
        payload: {
          errorCode: EFairPlayErrorCode.requestDeclined,
          error: message || null,
        },
      };

    default:
      return {
        success: false,
        payload: {
          errorCode: EFairPlayErrorCode.emptyResponse,
          error: message || null,
        },
      };
  }
}
